import React, { Component } from 'react';

import { storageKeys } from 'config/settings.json';

import BackImage from 'components/BackImage';
import StorageHandler from 'config/StorageHandler';

export default class WelcomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      agency: '',
      state: '',
    };
  }

  componentDidMount() {
    this.clearCache();
  }

  clearCache() {
    StorageHandler.remove(storageKeys.progress);
    window.location.href('/login');
  }

  render() {
    return (
      <div className="welcomeView">
        <BackImage />
        <div className="welcomeView__Wrapper">{'Removing caching and redirecting to login...'}</div>
      </div>
    );
  }
}
